import {needAuth} from "../instance/Instance";

async function getLeaseList(search, pageable) {
    console.log(">> 자산리스관리 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {

            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/asset/lease?'+pageStr,search);
    }catch (error){
        return error;
    }
}

async function removeLeases(ids) {
    try {
        return await needAuth.put('/asset/lease/delete', ids);
    }catch (error){
        return error
    }
}



async function getLease(id) {
    try{
        return  await needAuth.get('/asset/lease/'+id);
    }catch (error){
        return error;
    }
}

async function saveLease(lease, files, asset, contract) {

    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    const assetData = asset?.map(item => ({id : item.id}));
    lease.assetIds = assetData;

    const contractData = contract?.map(item => ({id : item.id}));
    lease.contractIds = contractData;

    formData.append(
        "assetLeaseRequestDto",
        new Blob([JSON.stringify(lease)], { type: "application/json" })
    );

    return await needAuth.post(`/asset/lease/create`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
}

async function updateLease(data) {
    try {
        return await needAuth.put(`/asset/lease`, data);
    }catch (error){
        return error
    }
}

async function createLeaseAssets(lease, asset) {
    try {
        const leaseAssets ={ leases : { id : lease }, assets : {id : asset.id} }
        return await needAuth.post(`/asset/lease/assets/create`, leaseAssets);
    }catch (error){
        return error
    }
}

async function removeLeaseAssets(lease, asset) {
    try {
        return await needAuth.delete(`/asset/lease/assets/delete?lease=`+lease+`&asset=`+asset.id);
    }catch (error){
        return error
    }
}

async function createLeaseContract(lease, contract) {
    try {
        const leaseAssets ={ leases : { id : lease }, contracts : {id : contract.id } }
        return needAuth.post(`/asset/lease/contract/create`, leaseAssets);
    }catch (error){
        return error
    }
}

async function removeLeaseContract(lease, contract) {
    try {
        return await needAuth.delete(`/asset/lease/contract/delete?lease=`+lease+`&contract=`+contract.id);
    }catch (error){
        return error
    }
}

async function getLeaseAssets(id) {
    try{
        return  await needAuth.get('/asset/lease/asset/'+id);
    }catch (error){
        return error;
    }
}

async function getLeaseContracts(id) {
    try{
        return  await needAuth.get('/asset/lease/contract/'+id);
    }catch (error){
        return error;
    }
}

export {getLeaseList, removeLeases, saveLease, getLease, updateLease, removeLeaseAssets, createLeaseAssets, createLeaseContract, removeLeaseContract, getLeaseAssets, getLeaseContracts};